import { FeatureToggleProvider } from 'src/app/shared/featureToggle';
import { getEnvironment } from 'src/app/utils/environment';
import { usePage } from 'src/app/v2/hooks/usePage';
import { useHirerAccountAndUserDataQuery } from 'src/graphql/generated';

export const FeatureToggleProviderV2 = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const pageId = usePage();
  const { data } = useHirerAccountAndUserDataQuery({
    variables: {
      // advertiserNation param has been deprecated and will be removed by the Monetization team in the future.
      advertiserNation: 'deprecated',
    },
    fetchPolicy: 'cache-only',
  });

  if (data?.hirerAccount?.__typename !== 'HirerAccount') {
    return null;
  }

  const input = {
    advertiserId:
      data?.currentAdvertiser.__typename === 'CurrentAdvertiserContext'
        ? data.currentAdvertiser.advertiserId
        : '',
    env: getEnvironment(),
    hirerAccount: {
      ...data?.hirerAccount,
      nation: data.hirerAccount.nation || '',
      isApproved: Boolean(data.hirerAccount.isApproved),
    },
    currentPage: pageId,
  };

  return <FeatureToggleProvider {...input}>{children}</FeatureToggleProvider>;
};
